var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var SwiperWidget = function () {
            function SwiperWidget(params) {
                _classCallCheck(this, SwiperWidget);

                this.swiperType = params.type;
                this.swiperSelector = document.querySelector(params.id);
                this.swiper = null;
                this.swiperParams = params.swiperParams || {};

                this.thumbsSwiperSelector = document.querySelector(params.id + 'Preview');
                this.thumbsSwiper = null;

                this.paginationDynamicBullets = params.pagination && params.pagination.dynamicBullets ? params.pagination.dynamicBullets : false;

                this.init();
            }

            _createClass(SwiperWidget, [{
                key: "init",
                value: function init() {
                    var _this = this;

                    switch (this.swiperType) {
                        case 'thumbs-gallery':
                            this.initThumbsGallery();
                            break;
                        default:
                            this.initDefaultSwiper();
                            break;
                    }

                    window.eventDispatcher.addEventListener('swiperSlideTo', function (data) {
                        if (_this.swiper.el.id === data.swiperSelector) {
                            _this.swiper.slideTo(data.slideIndex);
                        }
                    });
                }
            }, {
                key: "initDefaultSwiper",
                value: function initDefaultSwiper() {
                    var params = {
                        freeMode: false,
                        pagination: {
                            el: ".swiper-pagination",
                            dynamicBullets: this.paginationDynamicBullets
                        },
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev"
                        }
                    };
                    this.swiper = new Swiper(this.swiperSelector, Object.assign({}, params, this.swiperParams));
                }
            }, {
                key: "initThumbsGallery",
                value: function initThumbsGallery() {
                    this.thumbsSwiper = new Swiper(this.thumbsSwiperSelector, {
                        loop: false,
                        spaceBetween: 10,
                        slidesPerView: 8,
                        freeMode: false,
                        watchSlidesProgress: true,
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev"
                        }
                    });

                    this.swiper = new Swiper(this.swiperSelector, {
                        loop: false,
                        spaceBetween: 7,
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev"
                        },
                        pagination: {
                            el: ".swiper-pagination",
                            type: "fraction"
                        },
                        thumbs: {
                            swiper: this.thumbsSwiper
                        }
                    });
                }
            }]);

            return SwiperWidget;
        }();

        window.SwiperWidget = SwiperWidget;
    }, {}] }, {}, [1]);